var React = require('react');

function Signal (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.2895 13.3479C14.8321 14.7299 13.5377 15.7421 12 15.7421C10.4623 15.7421 9.16788 14.7397 8.71046 13.3479H0V20.3163C0 21.3869 0.875912 22.2628 1.94647 22.2628H22.0535C23.1241 22.2628 24 21.3869 24 20.3163V13.3479H15.2895Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M22.0535 1.73722H1.94647C0.875912 1.73722 0 2.61314 0 3.6837V11.4015H8.6326C9.01217 9.89294 10.3747 8.76399 12 8.76399C13.6253 8.76399 14.9878 9.88321 15.3674 11.4015H24V3.6837C24 2.61314 23.1241 1.73722 22.0535 1.73722Z","fill":"currentColor","key":1})]);
}

Signal.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Signal;

Signal.default = Signal;
